import React from 'react';
import classNames from 'classnames/bind';

import { env } from '@/lib/env';

import styles from './GlobalFooter.module.scss';

const cx = classNames.bind(styles);

const GlobalFooter = () => {
  return (
    <div className={cx('GlobalFooter')}>
      <div className={cx('inner')}>
        <div className={cx('terms')}>
          <a className={cx('item')} href={env('FOOTER_LINK_SERVICE_TERMS')} target="_blank" rel="noreferrer">
            이용약관
          </a>
          <a className={cx('item')} href={env('FOOTER_LINK_PRIVACY_POLICY')} target="_blank" rel="noreferrer">
            <strong>개인정보처리방침</strong>
          </a>
          <a className={cx('item')} href={env('FOOTER_LINK_DISCLAIMER')} target="_blank" rel="noreferrer">
            책임의 한계와 법적고지
          </a>
          {/* 추후 serviceNo 변경 필요 */}
          <a className={cx('item')} href={env('FOOTER_LINK_SUPPORT')} target="_blank" rel="noreferrer">
            고객센터
          </a>
        </div>
        <p className={cx('info')}>
          네이버 티켓·패키지 여행은 여행 상품 판매사에서 제공한 여행 상품의 정보를 비교, 중개하는 서비스입니다.
          <br />
          네이버(주)는 통신판매의 당사자가 아니며 상품 검색 결과, 구매 및 환불 등에 관련한 의무와 책임은 각 판매자에게
          있습니다.
        </p>
        <address className={cx('address')}>
          <span className={cx('item')}>사업자등록번호 : 220-81-62517</span>
          <span className={cx('item')}>통신판매업신고번호 : 제2006-경기성남-692호</span>
          <span className={cx('item')}>대표이사 : 최수연</span>
          <span className={cx('item')}>
            <a href={env('FOOTER_LINK_BIZ_INFO')} target="_blank" rel="noreferrer">
              사업자등록정보확인
            </a>
          </span>
          <span className={cx('item')}>호스팅 서비스 제공 : NAVER Cloud</span>
          <br />
          <span className={cx('item')}>주소 : 경기도 성남시 분당구 정자일로 95, NAVER 1784, 13561</span>
          <span className={cx('item')}>대표전화 : 1588-3820</span>
          <span className={cx('item')}>이메일 : ccnaver@naver.com</span>
        </address>
        <address className={cx('copyright')}>
          <a className={cx('logo')} href="https://www.naver.com/" target="_blank" rel="noreferrer" title="NAVER" />
          <em className={cx('txt')}>Copyright ©</em>
          <a className={cx('name')} href="https://www.navercorp.com/" target="_blank" rel="noreferrer">
            NAVER Corp.
          </a>
          <span className={cx('txt')}>All Rights Reserved.</span>
        </address>
      </div>
    </div>
  );
};

export default GlobalFooter;
